module.exports = __webpack_public_path__ + "static/media/logo-wbs-recruiting-international.65a1ba53.svg";